import { createColumnHelper } from "@tanstack/react-table"
import Switch from "react-switch"
import { useSortable } from "@dnd-kit/sortable"
import { getFormattedTime } from "utils"
import TableActionsColumn from "components/TableActionsColumn"
import { URL_PATHS } from "constants/index"
import { generatePath, Link } from "react-router-dom"

const columnHelper = createColumnHelper()

export const columnDef = [
  {
    id: "order",
    cell: ({ row }) => {
      const { attributes, listeners } = useSortable({
        id: row?.id,
      })
      return (
        <i
          {...attributes}
          {...listeners}
          className="bx bx-sm bx-menu"
          style={{ cursor: "pointer" }}
        />
      )
    },
  },
  {
    id: "select-col",
    header: ({ table }) => (
      <input
        type="checkbox"
        checked={table.getIsAllRowsSelected()}
        onChange={table.getToggleAllRowsSelectedHandler()}
      />
    ),
    cell: ({ row }) => {
      if (row?.depth > 0) {
        return (
          <input
            type="checkbox"
            checked={row.getIsSelected()}
            disabled={!row.getCanSelect()}
            onChange={row.getToggleSelectedHandler()}
          />
        )
      } else {
        return <></>
      }
    },
  },
  {
    id: "name",
    header: "Name",
    cell: ({ row }) => {
      if (row?.depth > 0) {
        return !row?.original?.name ? (
          "-"
        ) : (
          <Link
            to={generatePath(URL_PATHS.EDIT_EXPERIENCE, {
              vendor_id: row?.original?.vendor_id,
              id: row?.original?.id,
            })}
            className="text-primary text-decoration-underline"
          >
            {row?.original?.name}
          </Link>
        )
      } else {
        return !row?.original?.name ? "-" : row?.original?.name
      }
    },
  },
  {
    id: "business_unit",
    cell: ({ row }) => {
      if (row?.depth > 0) {
        return !row?.original?.business_unit
          ? "-"
          : row?.original?.business_unit?.name
      } else {
        return <></>
      }
    },
    header: "Business Unit",
  },
  {
    id: "hosts",
    cell: ({ row }) => {
      if (row?.depth > 0) {
        return !row?.original?.hosts
          ? "-"
          : row?.original?.hosts[0]?.display_name
      } else {
        return <></>
      }
    },
    header: "Created by",
  },
  {
    id: "updated_at",
    header: "Last Modified",
    cell: ({ row }) => {
      if (row?.depth > 0) {
        return !row?.original?.updated_at
          ? "-"
          : getFormattedTime(row?.original?.updated_at, "America/New_York")
      } else {
        return <></>
      }
    },
  },
  {
    accessorKey: "guests_nr",
    header: "# Users",
  },
  columnHelper.display({
    id: "published",
    header: "Published",
    cell: props => {
      if (props?.row?.depth > 0) {
        return (
          <Switch
            checked={props?.row?.original?.published}
            onChange={() => {
              props?.table?.options?.meta?.publishChangeHandler(
                props?.row?.original,
                !props?.row?.original?.published
              )
            }}
            onColor="#2ECC71"
            offColor="#E74C3C"
            name="publishCheck"
            height={20}
            width={40}
            handleDiameter={18}
            uncheckedIcon={false}
            checkedIcon={false}
          />
        )
      } else {
        return <></>
      }
    },
  }),
  columnHelper.display({
    id: "actions",
    cell: props => {
      if (props?.row?.depth > 0) {
        const actions = props?.table?.options?.meta?.actions
        return (
          <TableActionsColumn
            actions={actions}
            rowElement={props?.row?.original}
          />
        )
      } else {
        return <></>
      }
    },
  }),
]
